export default "__VITE_ASSET__BB0UZGSd__"